import { createIcon } from '@chakra-ui/react'

export const ClockIcon = createIcon({
  displayName: 'ClockIcon',
  viewBox: '0 0 20 21',
  path: (
    <svg viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10.5" r="9" stroke="black" strokeWidth="2" />
      <path
        d="M7.29395 13.1108L10.5833 10.8864"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M7.17383 5.83179L10.6022 10.8915"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),
})
